import { DatePicker } from 'antd';
import React from 'react';
import { formatDate } from 'utils';
import { FilterOptionsWrapper } from 'ui/Filter';
import dayjs from 'dayjs';

function RangePickerFilter({
  value,
  format = 'DD.MM.YYYY',
  picker = 'date',
  onFilterChange,
}) {
  const [start, end] = value;
  const rangeValue = [start ? dayjs(start) : null, end ? dayjs(end) : null];

  const handleChange = (range) => {
    if (!range) {
      onFilterChange([null, null]);
    } else {
      const [start, end] = range;
      const startDate = formatDate(start, 'YYYY-MM-DD');
      const endDate = formatDate(end, 'YYYY-MM-DD');
      onFilterChange([startDate, endDate]);
    }
  };

  return (
    <FilterOptionsWrapper>
      <DatePicker.RangePicker
        format={format}
        picker={picker}
        value={rangeValue}
        onChange={handleChange}
      />
    </FilterOptionsWrapper>
  );
}

export { RangePickerFilter };
